/**
 * 生成移动端专区详情路径。
 * 当前专区 SEO 统一使用主站结构 `/special/{areaId}`。
 * @param areaId 专区 ID
 * @returns 专区详情路径；参数缺失时返回空字符串
 */
export function mobileSpecialDetailPath(areaId: string | number | null | undefined): string {
	const aid = areaId != null && areaId !== '' ? String(areaId).trim() : '';
	if (!aid) return '';
	return `/special/${aid}`;
}
